module.exports = __webpack_public_path__ + "img/reactiveSystems.2ef195c6.svg";